export default "__VITE_ASSET__9f20b047__"